import React, { useState, useEffect } from 'react';
import Layout from '../components/Layout';

function TRCInventoryDashboard({ user, onLogout }) {
  const [stats, setStats] = useState({
    totalDevices: 0,
    inStock: 0,
    pendingRepair: 0,
    readyForDispatch: 0
  });

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">TRC Inventory Dashboard</h1>
          <p className="text-gray-600 mt-2">Overview of TRC store inventory</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Total Devices</p>
                <p className="text-3xl font-bold text-gray-800 mt-1">{stats.totalDevices}</p>
              </div>
              <div className="text-4xl">📦</div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">In Stock</p>
                <p className="text-3xl font-bold text-green-600 mt-1">{stats.inStock}</p>
              </div>
              <div className="text-4xl">✅</div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Pending Repair</p>
                <p className="text-3xl font-bold text-yellow-600 mt-1">{stats.pendingRepair}</p>
              </div>
              <div className="text-4xl">🔧</div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">Ready for Dispatch</p>
                <p className="text-3xl font-bold text-blue-600 mt-1">{stats.readyForDispatch}</p>
              </div>
              <div className="text-4xl">📤</div>
            </div>
          </div>
        </div>

        {/* Placeholder for more detailed analytics */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Inventory Trends</h2>
          <p className="text-gray-600">Analytics and trends will be displayed here.</p>
        </div>
      </div>
    </Layout>
  );
}

export default TRCInventoryDashboard;
